import React, { useLayoutEffect, useRef, useState } from 'react';
import { arrayOf, shape, string, object } from 'prop-types';
import throttle from 'lodash.throttle';
import clsx from 'clsx';
import useBreakpoint, { TABLET_LANDSCAPE } from 'hooks/useBreakpoint';

import DragScroll from 'components/DragScroll/DragScroll';
import BingoCard from 'components/BingoCard/BingoCard';

import styles from './LayoutWithFooterScroll.module.scss';

function LayoutWithFooterScroll({ items }) {
  const topRowRef = useRef(null);
  const spacerRef = useRef(null);
  const breakpoint = useBreakpoint();

  const [itemsTop, setItemsTop] = useState([]);
  const [itemsFooter, setItemsFooter] = useState([]);

  useLayoutEffect(() => {
    const wrapper = topRowRef.current;

    const onResize = throttle(() => {
      const wrapperWidth = wrapper.offsetWidth;
      const spacerWidth = spacerRef.current.clientWidth;
      const availableSlotsInTop = Math.floor(wrapperWidth / spacerWidth);
      const top = items.slice(0, availableSlotsInTop);
      const footer = items.slice(availableSlotsInTop);

      setItemsTop(top);
      setItemsFooter(footer);
    }, 500);

    // create an Observer instance
    const resizeObserver = new ResizeObserver(onResize);

    resizeObserver.observe(wrapper);

    return () => {
      resizeObserver.unobserve(wrapper);
    };
  }, [items]);

  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.isLandscape]: breakpoint === TABLET_LANDSCAPE,
      })}
    >
      <div className={styles.topRowWrapper}>
        <div ref={topRowRef} className={styles.topRow}>
          <div ref={spacerRef} className={styles.spacer} />

          {itemsTop.map((card) => (
            <div key={card.id} className={styles.item}>
              <BingoCard
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...card}
                hasFooter
              />
            </div>
          ))}
        </div>
      </div>

      <DragScroll classNameScrollbar={styles.scrollbar}>
        <div className={styles.footer}>
          {itemsFooter.map((card) => (
            <div key={card.id} className={styles.item}>
              <BingoCard
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...card}
                isSmall
                hasFooter
              />
            </div>
          ))}
        </div>
      </DragScroll>
    </div>
  );
}

LayoutWithFooterScroll.propTypes = {
  items: arrayOf(
    shape({
      id: string.isRequired,
      numbersMap: arrayOf(arrayOf(object)),
    })
  ),
};

LayoutWithFooterScroll.defaultProps = {
  items: [],
};

export default LayoutWithFooterScroll;
